import gql from 'graphql-tag';

export default gql`
  query GetExtendedEmail($accountId: ID!, $id: ID!) {
    getExtendedEmail(accountId: $accountId, id: $id) {
      body
    }
  }
`;
